/**
 * The rest of the invented congregation — what the office side of it looks
 * like. Same made-up people as `people.ts`; see that file for why they recur.
 *
 * Money is in cents here exactly as it is everywhere else in the codebase. A
 * marketing fixture that used floats would be teaching the wrong shape to the
 * next person who copies it.
 */

export const DEMO_OUTSTANDING = [
  {
    household: 'Adler',
    charge: 'Membership 5786',
    due: '1 Tishrei',
    cents: 180000,
    paid: 180000,
  },
  {
    household: 'Brummer',
    charge: 'Membership 5786',
    due: '1 Tishrei',
    cents: 180000,
    paid: 90000,
  },
  {
    household: 'Feldhandler',
    charge: 'Seats — Yamim Noraim',
    due: '1 Elul',
    cents: 54000,
    paid: 0,
  },
  {
    household: 'Kestenbaum',
    charge: 'Membership 5786',
    due: '1 Tishrei',
    cents: 180000,
    paid: 180000,
  },
  {
    household: 'Roitman',
    charge: 'Maos chittim',
    due: '1 Nissan',
    cents: 36000,
    paid: 36000,
  },
]

export const DEMO_CAMPAIGNS = [
  {
    name: 'Maos chittim 5786',
    pledgedCents: 1842000,
    goalCents: 2500000,
    gifts: 63,
  },
  {
    name: 'Building fund',
    pledgedCents: 9310000,
    goalCents: 15000000,
    gifts: 41,
  },
  {
    name: 'Matonos l’evyonim',
    pledgedCents: 726000,
    goalCents: 750000,
    gifts: 88,
  },
]

/**
 * A message as the composer holds it — tokens unresolved, because that is the
 * point being made: the body is written once and reads live data every time it
 * goes out.
 */
export const DEMO_MESSAGE = {
  subject: 'Shabbos Parshas Vayeira',
  body: [
    'Good Shabbos,',
    '',
    'Candle lighting is at {{candle_lighting}} and Mincha is {{mincha}}.',
    'Shacharis tomorrow is {{shacharis}}; the shiur follows kiddush.',
    '',
    '{{shul_name}}',
  ].join('\n'),
  audience: 'All members · email and text',
  recipients: 214,
}

/** What those tokens come out as, for the week the shot is set in. */
export const DEMO_MESSAGE_RESOLVED = [
  { token: '{{candle_lighting}}', value: '4:29 PM' },
  { token: '{{mincha}}', value: '4:34 PM' },
  { token: '{{shacharis}}', value: '8:45 AM' },
]

/**
 * Sends anchored to an occasion rather than a date — the reason they never need
 * rebuilding. "Two hours before candle lighting" resolves against whatever the
 * candle lighting is that week.
 */
export const DEMO_SCHEDULED = [
  {
    name: 'Weekly zmanim',
    when: 'Every Friday, 2 hours before candle lighting',
    next: 'Fri 4 Dec, 2:29 PM',
  },
  /*
   * Erev Shabbos Mevorchim, NOT Shabbos Mevorchim itself.
   *
   * The announcement is made in shul on Shabbos; the message about it cannot be,
   * and this row said "Shabbos Mevorchim, after Shacharis · Sat 12 Dec, 10:30
   * AM" — a send landing on Shabbos morning. Two panels away the product boasts
   * that it stays silent on Shabbos and Yom Tov, so the demo was contradicting
   * the guarantee, in front of the only audience that would notice immediately.
   *
   * Anything added to this list is a SEND time, so it belongs before Shabbos or
   * after it, never inside.
   */
  {
    name: 'Rosh Chodesh announcement',
    when: 'Erev Shabbos Mevorchim, 10:00 AM',
    next: 'Fri 11 Dec, 10:00 AM',
  },
  {
    name: 'Erev Yom Tov reminder',
    when: 'Erev Pesach, 8:00 AM',
    next: 'Wed 1 Apr, 8:00 AM',
  },
]

/**
 * The staff roster. Roles are what someone IS; permissions are what that lets
 * them do — which is why the shot shows both rather than a single "admin" flag.
 */
export const DEMO_STAFF = [
  { name: 'Yaakov Adler', role: 'Gabbai', can: 'Schedule, messaging' },
  { name: 'Dovid Feldhandler', role: 'Treasurer', can: 'Billing, donations' },
  { name: 'Shimon Brummer', role: 'Rov', can: 'Everything' },
]
